import threeStars from './threestars';
import zigzag from './zigzagga';

const svgs = {
    threeStars,
    zigzag
}

export default svgs;